import React, {useEffect, useState} from "react";

import './discarded-mails-table.scss'
import {useRecoilValue} from "recoil";
import {grpcMailServiceSelector} from "../../state/grpc";
import {
  DataTable,
  DataTableSkeleton,
  Pagination,
  Table, TableBody, TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow
} from "@carbon/react";

const DiscardedMailsTable = ({}) => {
  const mailService = useRecoilValue(grpcMailServiceSelector)
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)
  const [mails, setMails] = useState([])
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(25)
  const [totalSize, setTotalSize] = useState(0)

  const headers = [{
    key: 'id', header: 'ID'
  }, {
    key: 'subject', header: 'Oggetto'
  }, {
    key: 'date', header: 'Data'
  }, {
    key: 'senderAddress', header: 'Email sistema'
  }, {
    key: 'errorDescription', header: 'Errore'
  }];

  useEffect(() => {
    const req = new proto.api.ListDiscardedMailsRequest()
    const pageReq = new proto.api.PageRequest()
    pageReq.setPage(page)
    pageReq.setSize(size)
    pageReq.setSort("date desc")
    req.setPagination(pageReq)
    mailService.listDiscardedMails(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        const respObj = resp.toObject()
        setMails(respObj.mailsList)
        setTotalSize(respObj.pagination.total)
      }
      setLoading(false)
    })
  }, [size, page])

  if (loading) {
    return (
      <DataTableSkeleton
        columnCount={headers.length + 1}
        rowCount={5}
        headers={headers}
      />
    )
  }

  if (error) {
    return (
      <span>ERROR!</span>
    )
  }

  const handlePaginationChange = (newPage, newPageSize) => {
    if (newPageSize !== size) {
      setSize(newPageSize);
    }
    if (newPage !== page) {
      setPage(newPage)
    }
  }

  return (
    <DataTable
      rows={mails}
      headers={headers}
      render={({
                 rows,
                 headers,
                 getHeaderProps,
                 getRowProps,
                 getTableProps,
                 getTableContainerProps,
               }) => {
        return (
          <TableContainer title="Lista mail scartate"
                          description="Lista delle mail non elaborate con successo" {...getTableContainerProps()}>
            <Pagination
              totalItems={totalSize}
              backwardText="Precedente"
              forwardText="Successiva"
              pageSize={size}
              pageSizes={[10, 25, 50, 100]}
              itemsPerPageText="Elementi per pagina"
              pageRangeText={(_current, total) => `di ${total} ${total === 1 ? 'pagina' : 'pagine'}`}
              itemRangeText={(min, max, total) => `${min}–${max} of ${total} elementi`}
              onChange={({page, pageSize}) => handlePaginationChange(page, pageSize)}
            />
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (<TableHeader {...getHeaderProps({header})}>
                    {header.header}
                  </TableHeader>))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id} {...getRowProps({row})}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {cell.value}
                      </TableCell>
                    ))}
                  </TableRow>))}
              </TableBody>
            </Table>
          </TableContainer>);
      }}
    />
  )
}

export default DiscardedMailsTable